import { render, staticRenderFns } from "./adsorption-energy-detail.vue?vue&type=template&id=23236e3a&"
import script from "./adsorption-energy-detail.vue?vue&type=script&lang=js&"
export * from "./adsorption-energy-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports